import { render, staticRenderFns } from "./recharge.vue?vue&type=template&id=206bef7c&scoped=true"
import script from "./recharge.vue?vue&type=script&lang=js"
export * from "./recharge.vue?vue&type=script&lang=js"
import style0 from "./recharge.vue?vue&type=style&index=0&id=206bef7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "206bef7c",
  null
  
)

export default component.exports